import { render, staticRenderFns } from "./MyGroups.vue?vue&type=template&id=556d18dc&scoped=true&"
import script from "./MyGroups.vue?vue&type=script&lang=ts&"
export * from "./MyGroups.vue?vue&type=script&lang=ts&"
import style0 from "./MyGroups.vue?vue&type=style&index=0&id=556d18dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556d18dc",
  null
  
)

export default component.exports